// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, "Courier New", monospace;
}

p,
h1,
h2,
h3,
h4,
h5,
h6 {
  margin-bottom: 0px;
}

.modals {
  position: fixed; /* Stay in place */
  z-index: 1; /* Sit on top */
  padding-top: 100px; /* Location of the box */
  left: 0;
  top: 0;
  width: 100%; /* Full width */
  height: 100%; /* Full height */
  overflow: auto; /* Enable scroll if needed */
  background-color: rgb(0, 0, 0); /* Fallback color */
  background-color: rgba(0, 0, 0, 0.4); /* Black w/ opacity */
}

/* Modal Content */
.modal-contents {
  background-color: white;
  margin: auto;
  padding: 20px;
  border: 1px solid #888;
  width: 50%;
  border-radius: 6px;
}

/* The Close Button */
.close {
  color: #aaaaaa;
  float: right;
  font-size: 28px;
  font-weight: bold;
}

.close:hover,
.close:focus {
  color: #000;
  text-decoration: none;
  cursor: pointer;
}

.rowGaps {
  row-gap: 18px;
}

.columnGap {
  column-gap: 14px;
}

.chip {
  display: inline-block;
  padding: 0.5rem 1rem;
  border: 1px solid #ccc;
  border-radius: 16px;
  background-color: #1875FD;
  margin-right: 0.5rem;
  color: white;
}

/* Styling for the X mark */
.close-icon {
  margin-left: 0.5rem;
  cursor: pointer;
  color: white;
  font-weight: bold;
}

.close-icon:hover {
  color: #000;
}

.error {
  font-size: 13px;
  margin-top: 4px;
  margin-left: 4px;
}

/* global.scss */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5); /* Semi-transparent background */
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1050; /* Ensure it is above other content */
  overflow: hidden; /* Prevent scrolling */
}

.modal-content {
  background-color: white;
  padding: 20px;
  border-radius: 8px;
  width: 90%;
  max-width: 600px;
  z-index: 1051; /* Ensure it is above the overlay */
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.modal-body {
  margin-top: 10px;
}

.modal-footer {
  display: flex;
  justify-content: flex-end;
  margin-top: 10px;
}

.modal-overlay.hide {
  display: none;
}

.modal-overlay.show {
  display: flex;
}`, "",{"version":3,"sources":["webpack://./src/styles/global.scss"],"names":[],"mappings":"AAAA;EACE,SAAA;EACA,8JAAA;EAGA,mCAAA;EACA,kCAAA;AADF;;AAIA;EACE,+EAAA;AADF;;AAKA;;;;;;;EAOE,kBAAA;AAFF;;AAMA;EAEE,eAAA,EAAA,kBAAA;EACA,UAAA,EAAA,eAAA;EACA,kBAAA,EAAA,wBAAA;EACA,OAAA;EACA,MAAA;EACA,WAAA,EAAA,eAAA;EACA,YAAA,EAAA,gBAAA;EACA,cAAA,EAAA,4BAAA;EACA,8BAAA,EAAA,mBAAA;EACA,oCAAA,EAAA,qBAAA;AAJF;;AAOA,kBAAA;AACA;EACE,uBAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,UAAA;EACA,kBAAA;AAJF;;AASA,qBAAA;AACA;EACE,cAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;AANF;;AASA;;EAEE,WAAA;EACA,qBAAA;EACA,eAAA;AANF;;AASA;EACA,aAAA;AANA;;AAQA;EACE,gBAAA;AALF;;AAOA;EACE,qBAAA;EACA,oBAAA;EACA,sBAAA;EACA,mBAAA;EACA,yBAAA;EACA,oBAAA;EACA,YAAA;AAJF;;AAQA,2BAAA;AACA;EACE,mBAAA;EACA,eAAA;EACA,YAAA;EACA,iBAAA;AALF;;AAQA;EACE,WAAA;AALF;;AAQA;EACE,eAAA;EACA,eAAA;EACA,gBAAA;AALF;;AASA,gBAAA;AACA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,oCAAA,EAAA,gCAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA,EAAA,qCAAA;EACA,gBAAA,EAAA,sBAAA;AANF;;AASA;EACE,uBAAA;EACA,aAAA;EACA,kBAAA;EACA,UAAA;EACA,gBAAA;EACA,aAAA,EAAA,mCAAA;AANF;;AASA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;AANF;;AASA;EACE,gBAAA;AANF;;AASA;EACE,aAAA;EACA,yBAAA;EACA,gBAAA;AANF;;AASA;EACE,aAAA;AANF;;AASA;EACE,aAAA;AANF","sourcesContent":["body {\r\n  margin: 0;\r\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\r\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\r\n    sans-serif;\r\n  -webkit-font-smoothing: antialiased;\r\n  -moz-osx-font-smoothing: grayscale;\r\n}\r\n\r\ncode {\r\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\r\n    monospace;\r\n}\r\n\r\np,\r\nh1,\r\nh2,\r\nh3,\r\nh4,\r\nh5,\r\nh6 {\r\n  margin-bottom: 0px;\r\n}\r\n\r\n        \r\n.modals {\r\n  // display: none; /* Hidden by default */\r\n  position: fixed; /* Stay in place */\r\n  z-index: 1; /* Sit on top */\r\n  padding-top: 100px; /* Location of the box */\r\n  left: 0;\r\n  top: 0;\r\n  width: 100%; /* Full width */\r\n  height: 100%; /* Full height */\r\n  overflow: auto; /* Enable scroll if needed */\r\n  background-color: rgb(0,0,0); /* Fallback color */\r\n  background-color: rgba(0,0,0,0.4); /* Black w/ opacity */\r\n}\r\n\r\n/* Modal Content */\r\n.modal-contents {\r\n  background-color: white;\r\n  margin: auto;\r\n  padding: 20px;\r\n  border: 1px solid #888;\r\n  width: 50%;\r\n  border-radius: 6px;\r\n \r\n  \r\n}\r\n\r\n/* The Close Button */\r\n.close {\r\n  color: #aaaaaa;\r\n  float: right;\r\n  font-size: 28px;\r\n  font-weight: bold;\r\n}\r\n\r\n.close:hover,\r\n.close:focus {\r\n  color: #000;\r\n  text-decoration: none;\r\n  cursor: pointer;\r\n}\r\n\r\n.rowGaps{\r\nrow-gap: 18px;\r\n}\r\n.columnGap{\r\n  column-gap: 14px;\r\n}\r\n.chip {\r\n  display: inline-block;\r\n  padding: 0.5rem 1rem;\r\n  border: 1px solid #ccc;\r\n  border-radius: 16px;\r\n  background-color: #1875FD;\r\n  margin-right: 0.5rem;\r\n  color:white\r\n  \r\n}\r\n\r\n/* Styling for the X mark */\r\n.close-icon {\r\n  margin-left: 0.5rem;\r\n  cursor: pointer;\r\n  color: white;\r\n  font-weight: bold;\r\n}\r\n\r\n.close-icon:hover {\r\n  color: #000;\r\n}\r\n\r\n.error{\r\n  font-size: 13px;\r\n  margin-top: 4px;\r\n  margin-left: 4px;\r\n}\r\n\r\n\r\n/* global.scss */\r\n.modal-overlay {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  background-color: rgba(0, 0, 0, 0.5); /* Semi-transparent background */\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  z-index: 1050; /* Ensure it is above other content */\r\n  overflow: hidden; /* Prevent scrolling */\r\n}\r\n\r\n.modal-content {\r\n  background-color: white;\r\n  padding: 20px;\r\n  border-radius: 8px;\r\n  width: 90%;\r\n  max-width: 600px;\r\n  z-index: 1051; /* Ensure it is above the overlay */\r\n}\r\n\r\n.modal-header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n}\r\n\r\n.modal-body {\r\n  margin-top: 10px;\r\n}\r\n\r\n.modal-footer {\r\n  display: flex;\r\n  justify-content: flex-end;\r\n  margin-top: 10px;\r\n}\r\n\r\n.modal-overlay.hide {\r\n  display: none;\r\n}\r\n\r\n.modal-overlay.show {\r\n  display: flex;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
